import styled, { keyframes } from 'styled-components';
import { getTheme } from '@material-dev/thread';

const pulseAnimation = keyframes`
  from {
    opacity: 1;
  }

  to {
    transform: scale(3);
    opacity: 0;
  }
`;

const Pulse = styled.div`
  position: relative;
  height: 30px;
  width: 30px;
  outline: 0;
  cursor: pointer;

  &:before,
  &:after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 12px;
    height: 12px;
    margin-left: -6px;
    margin-top: -6px;
    background: ${props => getTheme(props).buttons.primary.backgroundColor};
    border-radius: 50%;
  }

  &:after {
    animation: ${pulseAnimation} 2s infinite;
  }
`;

export default Pulse;



// WEBPACK FOOTER //
// ./src/app/admin/components/Hotspot/Pulse.js